const LoadingComponent = (props) => {
	
	return (
		<>
			<div className={`bg-loader ${props.className || ''} ${!props.loading ? 'd-none' : ''}`}>
				<span className="loader2"></span>
			</div>
		</>
	)
}
export default LoadingComponent;